import { render, staticRenderFns } from "./FilterAmount.vue?vue&type=template&id=ec21264c&scoped=true&"
import script from "./FilterAmount.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilterAmount.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec21264c",
  null
  
)

export default component.exports